export default "__VITE_ASSET__VqTjV8X1__"